import { GoalStats } from 'apps/aiAutomation/store/engagementGoal/schemas'

export const DefaultGoalStats: GoalStats = {
  started: 0,
  achieved: 0,
}
